import { IPositionNameSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/position-name-section/position-name-section.types'
import { FormikProps } from 'formik'
import { useState, useEffect } from 'react'

interface IRichTextFields {
  descriptionRichText: string
  specialInstructionsRichText: string
  whatToWearRichText: string
  travelTipsRichText: string
}

interface IFieldErrors {
  descriptionRichText?: string
  whatToWearRichText?: string
}

export const useRichFields = (formik: FormikProps<IPositionNameSectionFormValues>) => {
  const { values, setFieldValue } = formik

  const [richTextFields, setRichTextFields] = useState<IRichTextFields>({
    descriptionRichText: values.description_rich_text || '',
    specialInstructionsRichText: values.special_instructions_rich_text || '',
    whatToWearRichText: values.what_to_wear_rich_text || '',
    travelTipsRichText: values.travel_tips_rich_text || '',
  })

  const [fieldErrors, setFieldErrors] = useState<IFieldErrors>({})

  const resetRichTextFields = () => {
    setRichTextFields({
      descriptionRichText: values.description_rich_text || '',
      specialInstructionsRichText: values.special_instructions_rich_text || '',
      whatToWearRichText: values.what_to_wear_rich_text || '',
      travelTipsRichText: values.travel_tips_rich_text || '',
    })
  }

  // Set initial values
  useEffect(() => {
    setRichTextFields({
      descriptionRichText: values.description_rich_text || '',
      specialInstructionsRichText: values.special_instructions_rich_text || '',
      whatToWearRichText: values.what_to_wear_rich_text || '',
      travelTipsRichText: values.travel_tips_rich_text || '',
    })
  }, [
    values.description_rich_text,
    values.special_instructions_rich_text,
    values.what_to_wear_rich_text,
    values.travel_tips_rich_text,
  ])

  // Update rich text field
  const updateRichTextField = (field: string, value: string) => {
    setRichTextFields((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  // Validate fields
  useEffect(() => {
    const newErrors: IFieldErrors = {}

    // Validate description field
    if (!richTextFields.descriptionRichText.trim()) {
      newErrors.descriptionRichText = 'Required'
    }

    // Validate what to wear field
    if (!richTextFields.whatToWearRichText.trim()) {
      newErrors.whatToWearRichText = 'Required'
    }

    setFieldErrors(newErrors)
  }, [richTextFields.descriptionRichText, richTextFields.whatToWearRichText])

  const setRichTextFieldsInFormik = () => {
    setFieldValue('description_rich_text', richTextFields.descriptionRichText)
    setFieldValue('special_instructions_rich_text', richTextFields.specialInstructionsRichText)
    setFieldValue('what_to_wear_rich_text', richTextFields.whatToWearRichText)
    setFieldValue('travel_tips_rich_text', richTextFields.travelTipsRichText)
  }

  return {
    ...richTextFields,
    fieldErrors,
    updateRichTextField,
    resetRichTextFields,
    setRichTextFieldsInFormik,
  }
}
